import React, { useEffect } from 'react';
import { localization } from './localizations';
import { getTenant } from '../../../../../api/TenantApi';
import { BdsBanner, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { isValidDomain } from '../../../../../utils/domainUtils';
import { useContentLocalizer } from '../../../../../hooks/useContentLocalizer';

const DataProtectionAlert: React.FC = () => {
  const ALLOWED_DOMAINS = ['Golden', 'Dobermann'];
  const content = useContentLocalizer(localization);
  const [showAlert, setShowAlert] = React.useState<boolean | null>(null);

  useEffect(() => {
    const fetchTenant = async () => {
      const tenant = await getTenant();
      const shouldShowBanner = isValidDomain(tenant?.clusterName, ALLOWED_DOMAINS);
      setShowAlert(shouldShowBanner);
    };

    fetchTenant();
  });

  return showAlert ? (
    <BdsBanner variant="info" context="outside" className="mb4">
      <BdsTypo variant="fs-14" tag="p" bold="bold">
        {content.header.title}
      </BdsTypo>
    </BdsBanner>
  ) : null;
};

export { DataProtectionAlert };
